/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum HandleMessageResult {
  Error = 0,
  Success = 1,
  InvalidCase = 2,
  InvalidMessage = 3,
  InvalidUser = 4,
}
